module.exports = __webpack_public_path__ + "fonts/Poppins-Black.0573b923.ttf";